import Isotope from 'isotope-layout';

export default function initGrid(block) {
  const grid = block.querySelector('.grid');

  if (!grid) return;

  const filter = block.querySelector('.filter');
  const isotope = new Isotope(grid, {
    layoutMode: 'masonry',
    itemSelector: '.grid-item',
    percentPosition: true,
    masonry: {
      columnWidth: '.grid-sizer',
      gutter: '.gutter-sizer',
    },
  });

  if (!filter) return;

  filter.querySelectorAll('button').forEach((button) => {
    button.addEventListener('click', function () {
      const filterValue = this.getAttribute('data-filter');
      isotope.arrange({ filter: filterValue });
    });
  });
}
